module.exports = __webpack_public_path__ + "static/img/az.ee61daa1.svg";